<template>
  <div>
    <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="title" width="1000px" :before-close="cancel" append-to-body class="app-main-inner change-charge-window">
      <div class="app-main-inner-row">
        <el-form label-position="right" label-width="90px" :model="adjustCharge">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ChargeItem')">
                <cargo-advance-select
                  filterable
                  :method-params="getChargeItemFilter()"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :default-value="Number(adjustCharge.chargeItemId) || ''"
                  style="width:386px;"
                  options-width="200px"
                  tag-value="itemId"
                  tag-name="zhName"
                  :disabled="!isEditing"
                  @parentCallBack="onChangeCompany"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_relatedContainerNo')">
                <el-select
                  ref="select"
                  v-model="adjustCharge.relationContainerNo"
                >
                  <el-option
                    v-for="(item,index) in relatedContainerOption"
                    :key="index"
                    :label="item['containerNo']"
                    :value="item['containerNo']"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_relatedBLNo')">
                <el-select
                  ref="select"
                  v-model="adjustCharge.relatedMbl"
                >
                  <el-option-group
                    v-for="group in blOption"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(item,index) in group.options"
                      :key="index"
                      :label="item['chargeRelatedBLNo']"
                      :value="item['chargeRelatedBLNo']"
                    />
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item v-show="customerSalesDisplayStar" :label="$t('SeaExport.AccountObject')">
                <el-input value="*" :disabled="true" style="width:386px;" />
              </el-form-item>
              <el-form-item v-show="!customerSalesDisplayStar" :label="$t('SeaExport.AccountObject')">
                <cargo-advance-select
                  v-if="arSettlementUnitOptional && isAr"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :method-params="{active:true}"
                  options-width="200px;"
                  tag-name="chineseName"
                  :static-options="companyFactorySigns"
                  @parentCallBack="textAccountCode_changeHandler"
                />
                <cargo-sales-company-select
                  v-else-if="accountObjectControlMode && isAr"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :disabled="!isEditing"
                  options-width="200px;"
                  tag-name="chineseName"
                  @parentCallBack="textAccountCode_changeHandler"
                />
                <cargo-advance-select
                  v-else
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.accountId) || ''"
                  :disabled="!isEditing"
                  options-width="200px;"
                  tag-name="chineseName"
                  @parentCallBack="textAccountCode_changeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.ContactPerson')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_Contact"
                  options-width="160px;"
                  filterable
                  :cache="false"
                  :disabled="!isEditing"
                  :default-value="adjustCharge.contactPerson || ''"
                  :static-options="contactArray"
                  @parentCallBack="item=>adjustCharge.contactPerson=item.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('FinanceManage.charge_invoiceHeader')">
                <cargo-advance-select
                  :filterable="true"
                  :filter-tag-names="['title']"
                  filter-type="global"
                  :allow-create="!settlementUnitOptional"
                  :default-value="adjustCharge.invoiceTitle"
                  :disabled="!isEditing"
                  options-width="200px;"
                  tag-value="title"
                  tag-name="title"
                  :static-options="invoiceTitleList"
                  @parentCallBack="textInvoiceTitleChangeHandle"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-show="customerSalesDisplayStar" :label="$t('SeaExport.settlementAgent')">
                <el-input value="*" :disabled="true" style="width:386px;" />
              </el-form-item>
              <el-form-item v-show="!customerSalesDisplayStar" :label="$t('SeaExport.settlementAgent')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="Number(adjustCharge.settlementAgentId) || 0"
                  :disabled="!isEditing"
                  :static-options="settlementAgentList"
                  options-width="200px;"
                  tag-name="chineseName"
                  @parentCallBack="onSettlementAgentChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Unit')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_ChargeUnit"
                  filterable
                  :clearable="false"
                  options-width="100px"
                  :disabled="!isEditing"
                  :default-value="adjustCharge.measure || ''"
                  @parentCallBack="combMeasureChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Quantity2')">
                <el-input-number v-model="adjustCharge.quantity" :max="999999999" :min="-999999999" :precision="3" style="width: 143px;" :controls="false" :disabled="!isEditing" @change="txtQuantityChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.UnitRate')">
                <el-input-number v-model="adjustCharge.unitRate" :max="999999999" :min="-999999999" :precision="3" style="width: 143px;" :controls="false" :disabled="!isEditing" @change="txtUnitRateChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.ExchangeRate')">
                <num-input
                  v-model="adjustCharge.exchangeRate"
                  :precision="8"
                  :truncated-precision="exchangeRatePrecision"
                  :min="0"
                  :max="999999999"
                  class="input-center"
                  style="width: 143px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="inputIncludingTaxUnitPrice" :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_unitPriceIncludeTax')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'unitPriceIncludeTax'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.unitPriceIncludeTax"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  options-width="130px"
                  :disabled="!isEditing"
                  :static-options="[{code:true,value:$t('SeaExport.Yes')},{code:false,value:$t('SeaExport.No')}]"
                  :filter-tag-names="['value']"
                  @parentCallBack="unitPriceIncludeTaxChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="isAdjust" :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Currency')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :default-value="adjustCharge.currency || ''"
                  options-width="100px"
                  :disabled="!isEditing"
                  @parentCallBack="textCurrencyChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="needMakeInvoice" :label="$t('SeaExport.IsNeedInvoice')">
                <cargo-advance-select
                  filterable
                  :fields="['value']"
                  :callback-params="{key:'needInvoice'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.needInvoice"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  options-width="100px"
                  :disabled="!isEditing"
                  :static-options="[{code:false,value:$t('CargoMsg.Cargo_No')},{code:true,value:$t('CargoMsg.Cargo_Yes')}]"
                  :filter-tag-names="['value']"
                  @parentCallBack="item=>adjustCharge.needInvoice=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="!salesDetail" :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_DateType')">
                <cargo-advance-select
                  :disabled="!isEditing"
                  :cache="false"
                  :clearable="false"
                  tag-name="name"
                  tag-value="code"
                  :static-options="dateTypeArray"
                  :default-value="dateType"
                  @parentCallBack="onDateTypeChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.Oversea')">
                <cargo-advance-select
                  filterable
                  :clearable="false"
                  :fields="['value']"
                  :callback-params="{key:'oversea'}"
                  callback-method-type="value"
                  :default-value="adjustCharge.oversea"
                  :cache="false"
                  tag-value="code"
                  tag-name="value"
                  style="width: 143px;"
                  :disabled="!isEditing || !canChangeOverseaOfCharge"
                  :static-options="[{code:false,value:$t('CargoMsg.Cargo_Domestic')},{code:true,value:$t('CargoMsg.Cargo_International')}]"
                  :filter-tag-names="['value']"
                  options-width="100px"
                  @parentCallBack="item=>adjustCharge.oversea=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="salesDetail" :span="6">
              <el-form-item :label="$t('FinanceManage.charge_freightCollectOrPrepaid')">
                <cargo-advance-select
                  :disabled="!isEditing"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  filterable
                  :clearable="true"
                  tag-value="code"
                  :default-value="adjustCharge.ppcc || ''"
                  @parentCallBack="item=>adjustCharge.ppcc=item.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.IncludingTaxAmount')">
                <el-input-number v-model="adjustCharge.amount" :max="999999999" :min="-999999999" :precision="2" style="width: 143px;" :controls="false" :disabled="!isEditing" @change="textAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.ExcludingTaxAmount')">
                <el-input-number :max="999999999" :min="-999999999" :value="!needInvoiceNo ? adjustCharge.excludingTaxAmount : adjustCharge.amount" :disabled="!isEditing" :precision="2" style="width: 143px;" :controls="false" @input="val=>{adjustCharge.excludingTaxAmount=val}" @change="excludingTaxAmountChangeHandler" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.BillAmount')">
                <el-input-number v-model="adjustCharge.taxAmount" :max="999999999" :min="-999999999" :precision="2" style="width: 143px;" :controls="false" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-show="!isAdvance" :label="$t('SeaExport.TaxRate')">
                <el-input-number :max="999999999" :min="-999999999" :value="isNaN(adjustCharge.taxRate) ? '0' : adjustCharge.taxRate" :precision="2" style="width: 143px;" :controls="false" :disabled="!isEditing" @input="val=>{adjustCharge.taxRate=val}" @change="txtRateChangeHandler" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item v-show="needInvoiceNo" :label="$t('SeaExport.InvoiceNo')">
                <el-input v-model="adjustCharge.invoiceNo" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('SeaExport.Remarks')">
                <el-input v-model="adjustCharge.remarks" type="textarea" :rows="5" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item v-show="applyChangeCharge" :label="$t('ChangeCharge.changeReason')">
                <el-input v-model="changeReason" type="textarea" :rows="5" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getContacts } from '@/api/partner/contact'
import { deepCopy } from '@/utils/commonUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { Charge } from '@/class/model/act/Charge'
import { Company } from '@/class/model/mdm/Company'
import { saveAdjustJob } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import { createChangeCharge } from '@/api/clearing/changeCharge'
import StrUtils from '@/utils/StrUtils'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { multiply } from '@/utils/commonUtil'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
export default {
  name: 'ChangeChargeWindow',
  components: { CargoAdvanceSelect, CargoSalesCompanySelect, NumInput },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true }, // 弹框打开时默认传递条件
    applyChangeCharge: { type: Boolean, default: false }, // 是否申请更改费用
    location: { type: String, required: false },
    customerSalesDisplayStar: { type: Boolean, default: false } // 销售查询-修改应收费用：结算对象：不允许修改、以*号显示
  },
  data() {
    const ADJUSTMENT_DATE = { code: 'AdjustmentDate', name: this.$t('Message.ByAdjustmentDate') }
    const BUSINESS_DATE = { code: 'BusinessDate', name: this.$t('Message.ByBusinessDate') }
    // 日期类型
    let dateType = LocalStorageUtilsNew.getConfiguration(this.dateTypeConfigKey, 'string')
    if (!dateType) {
      dateType = ADJUSTMENT_DATE.code
    }
    return {
      userId: 0,
      officeId: 0,
      departmentId: 0,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']) // 是否有应收受控费用权限
      },
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      rowData: [],
      title: '新增改单费用',
      isEditing: true, // 默认不能编辑
      ADJUSTMENT_DATE,
      BUSINESS_DATE,
      dateTypeArray: [ADJUSTMENT_DATE, BUSINESS_DATE], // 日期类型数组
      dateType,
      blOption: [],
      relatedContainerOption: [],
      contactArray: [],
      companyFactorySigns: [],
      isAdjust: false, // 是否调整
      salesDetail: false, // 是否销售页面
      editMode: null, // 调整模式【新增/修改/删除 add/edit/del】
      isAdvance: false, //
      isAr: false,
      job: null,
      lob: '',
      charge: false,
      companyTitle: null,
      costCharge: null,
      canChangeOverseaOfCharge: false, // 是否允许修改费用中国内国外的选项
      canChangeOverseaOfChargeValue: 0,
      adjustCharge: {}, // 调整的费用
      settlementAgentList: [],
      needInvoiceNo: false,
      needMakeInvoice: true, // 是否显示是否开票
      selCurrency: false,
      changeReason: '', // 更改原因
      loading: false,
      isSpecialExpenseEntryFunction: false,
      arSettlementUnitOptional: false, // 工厂参数
      accountObjectControlMode: false, // 结算单位控制模式
      invoiceTitleList: [],
      settlementUnitOptional: false,
      inputIncludingTaxUnitPrice: 0 // 单价是否含税参数
    }
  },
  computed: {
    dateTypeConfigKey() {
      return this.$route.name + '_ChangeChargeWindow_DateType'
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.adjustCharge.currency)
    }
  },
  watch: {
    // 监听结算对象变化
    'adjustCharge.accountId': {
      handler(newAccountId, oldAccountId) {
        if (newAccountId !== oldAccountId) {
          this.loadSettlementAgents(newAccountId)
        }
      },
      immediate: true
    },
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
    this.userId = this.$store.getters.userId
    this.officeId = this.$store.getters.currentOfficeId
    this.departmentId = this.$store.getters.currentDeptId
  },
  beforeMount() {},
  beforeDestroy() {
    LocalStorageUtilsNew.setConfiguration(this.dateTypeConfigKey, this.dateType)
  },
  methods: {
    // 初始化权限及配置参数
    async initializeHandler() {
      const defaultProperties = this.defaultProperties
      if (this.defaultProperties) {
        // 初始化本界面需要的属性
        this.editMode = Object.prototype.hasOwnProperty.call(defaultProperties, 'editMode') ? defaultProperties['editMode'] : this.editMode
        this.isAdjust = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdjust') ? defaultProperties['isAdjust'] : this.isAdjust // 是否调整
        this.salesDetail = Object.prototype.hasOwnProperty.call(defaultProperties, 'salesDetail') ? defaultProperties['salesDetail'] : this.salesDetail // 是否销售页面
        this.isAdvance = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAdvance') ? defaultProperties['isAdvance'] : this.isAdvance
        this.needMakeInvoice = Object.prototype.hasOwnProperty.call(defaultProperties, 'needMakeInvoice') ? defaultProperties['needMakeInvoice'] : this.needMakeInvoice
        this.isAr = Object.prototype.hasOwnProperty.call(defaultProperties, 'isAr') ? defaultProperties['isAr'] : this.isAr
        this.job = Object.prototype.hasOwnProperty.call(defaultProperties, 'job') ? defaultProperties['job'] : this.job
        this.charge = Object.prototype.hasOwnProperty.call(defaultProperties, 'charge') ? defaultProperties['charge'] : this.charge
        this.needInvoiceNo = Object.prototype.hasOwnProperty.call(defaultProperties, 'needInvoiceNo') ? defaultProperties['needInvoiceNo'] : this.needInvoiceNo
        this.companyFactorySigns = Object.prototype.hasOwnProperty.call(defaultProperties, 'companyFactorySigns') ? defaultProperties['companyFactorySigns'] : this.companyFactorySigns
        // 删除调整 不能编辑，新增、修改可以
        this.isEditing = this.editMode && this.editMode !== 'del'
        this.lob = this.job.lob
      }
      // 初始化job
      const job = new Job(this.job)
      if (job) {
        // 加载数据
        job.charges = null
        await Promise.all([
          job.getSeaEQ(),
          job.getCharges(),
          job.getCargoDoc()
        ])
      }
      // 配置参数
      this.canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge')) > 0
      this.canChangeOverseaOfChargeValue = parseInt(cache.config.get('canChangeOverseaOfCharge'))
      this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.inputIncludingTaxUnitPrice = Number(cache.config.get('InputIncludingTaxUnitPrice'))
      this.settlementUnitOptional = String(cache.config.get('ToExoSystem')) === 'HC'
    },
    async onShow() {
      await cache.load(cacheName.CONFIG)
      await this.initializeHandler()
      if (this.editMode) {
        //
        // 若非增加调整，则将数据库中的费用替换界面传过来的费用，避免界面传过来的费用对象不完整
        if (this.charge && this.editMode !== 'add' && this.job.charges && this.job.charges.length > 0) {
          for (const c of this.job.charges) {
            if (c.uuid === this.charge.uuid) {
              this.charge = c
              break
            }
          }
        }
        // 设置窗口标题
        if (this.editMode === 'add') {
          if (this.applyChangeCharge) {
            this.title = this.$t('ChangeCharge.applyAddCharge')
          } else {
            this.title = this.isAdjust ? this.$t('Message.AddChangeCharge') : this.$t('Message.AddCharge')
          }
          if (this.defaultProperties.title) {
            this.title = this.defaultProperties.title
          }
          this.charge.receivable = this.isAr
          this.charge.taxRate = ChargeUtils.getTaxRateAtCreateCharge(this.charge)
        } else if (this.editMode === 'edit') {
          if (this.applyChangeCharge) {
            this.title = this.$t('ChangeCharge.applyChangeCharge')
          } else {
            this.title = this.isAdjust ? this.$t('Message.EditChangeCharge') : this.$t('Message.EditCharge')
          }
          if (this.defaultProperties.title) {
            this.title = this.defaultProperties.title
          }
        } else {
          this.title = this.$t('Message.DeleteAdjustment')
        }
      }
      // 浅拷贝费用对象
      this.adjustCharge = deepCopy(this.charge)
      const adjustCharge = this.adjustCharge
      // CARGO-39247 对账新版-对账，点击查询报错
      if (adjustCharge && !adjustCharge.measure) {
        adjustCharge.measure = 'NML'
      }
      if (this.isAdjust && adjustCharge) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(adjustCharge.branchId)
        if (this.editMode === 'add') {
          const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, adjustCharge.currency, new Date(), adjustCharge.branchId)
          adjustCharge.exchangeRate = isNaN(exchangeRate) ? 0 : exchangeRate
        }
        // 给界面显示框初始化值
        const isInit = this.editMode && (this.editMode === 'edit' || this.editMode === 'del')
        adjustCharge['accountId'] = isInit ? adjustCharge['accountId'] : ''
        adjustCharge['contactPerson'] = isInit ? adjustCharge['contactPerson'] : ''
        const currency = adjustCharge['currency'] !== this.selCurrency ? adjustCharge['currency'] : this.selCurrency
        adjustCharge['currency'] = isInit ? currency : localCurrency
        adjustCharge['quantity'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['quantity'], 3) : 1.000
        adjustCharge['unitRate'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['unitRate'], 2) : 0.00
        adjustCharge['invoiceNo'] = isInit ? adjustCharge['invoiceNo'] : ''
        adjustCharge['chargeItemId'] = isInit ? adjustCharge['chargeItemId'] : ''
        const excludingTaxAmount = !this.needInvoiceNo ? NumberUtils.roundHalfUp(adjustCharge['excludingTaxAmount'], 2) : NumberUtils.roundHalfUp(adjustCharge['amount'], 2)
        adjustCharge['excludingTaxAmount'] = isInit ? excludingTaxAmount : 0.00
        adjustCharge['amount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['amount'], 2) : 0.00
        adjustCharge['taxAmount'] = isInit ? NumberUtils.roundHalfUp(adjustCharge['taxAmount'], 2) : 0.00
        adjustCharge['auditDate'] = new Date()
        adjustCharge['remarks'] = isInit ? adjustCharge['remarks'] : ''
        adjustCharge['measure'] = isInit ? adjustCharge['measure'] : 'NML'
        adjustCharge['needInvoice'] = isInit ? adjustCharge['needInvoice'] : true
        adjustCharge['controlled'] = isInit ? adjustCharge['controlled'] : false
        adjustCharge['oversea'] = isInit ? adjustCharge['oversea'] : false
        adjustCharge['relatedMbl'] = isInit ? adjustCharge['relatedMbl'] : ''
        adjustCharge['relationContainerNo'] = isInit ? adjustCharge['relationContainerNo'] : ''
        if (!isInit && this.canChangeOverseaOfChargeValue === 3) {
          // 是否允许修改国内国外(0=不允许修改国内国外;1=允许修改国内国外;2=默认国内,允许修改;3=默认国外,允许修改;)
          adjustCharge['oversea'] = true
        }
        if (adjustCharge['accountId']) {
          this.loadContacts(adjustCharge['accountId'])
        }
      }
      await this.initCargoDocSet()
      // 获取开票抬头列表并设置默认值
      await this.loadShowInvoiceTitle()
    },
    async saveEvent() {
      if (!await this.validateCharge()) return
      //
      const adjustCharge = this.adjustCharge
      let item = null // 改单增加调整

      if (this.editMode === 'add') {
        item = new Charge().fillDefaultValue().getData()
        item.jobUuid = this.job.uuid
        item.businessDate = this.job.businessDate
        item.inputBy = this.userId
        item.inputDate = new Date()
        item.inputByDep = this.departmentId
        item.branchId = this.officeId
        item.accountId = Number(adjustCharge.accountId)
        if (this.canChangeOverseaOfCharge) {
          item.oversea = adjustCharge.oversea
        } else {
          const company = await Company.getCompanyById(Number(adjustCharge.accountId))
          if (company && Object.prototype.hasOwnProperty.call(company, 'cmpIdx')) {
            item.oversea = company.overseaAgent
          }
        }
        item.receivable = this.isAr
        item.chargeItemId = adjustCharge.chargeItemId
        item.currency = adjustCharge.currency
        item.verifiedAmount = 0
        const localCurrency = RateUtil.localCurrencyByOfficeId(item.branchId)
        item.localCurrency = localCurrency
        if (this.isAdjust) { item.exchangeRate = isNaN(adjustCharge.exchangeRate) ? 0 : Number(adjustCharge.exchangeRate) } else { item.exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, item.currency, new Date(), item.branchId) }
        item.inputBy = this.userId
        item.advance = this.charge.advance
        item.adjustment = this.isAdjust
        if (this.salesDetail) {
          item.adjustment = false
        }
        item.measure = adjustCharge.measure
        item.quantity = parseFloat(adjustCharge.quantity)
        item.unitRate = parseFloat(adjustCharge.unitRate)
        item.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
        item.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
        item.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
        item.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
        item.offsetState = 0
        item.chargeState = 0
        item.confirmState = this.charge.confirmState
        if (this.needInvoiceNo) {
          item.invoiceNo = adjustCharge.invoiceNo
        }
        item.contactPerson = adjustCharge.contactPerson
        item.settlementAgentId = adjustCharge.settlementAgentId
        item.remarks = adjustCharge.remarks
        item.needInvoice = adjustCharge.needInvoice
        item.controlled = adjustCharge.controlled
        // CARGO-7916 更新费用序号
        item.serialNumber = this.refreshSerialNumber(this.isAr, this.job.charges)
        item.invoiceTitle = adjustCharge.invoiceTitle
        item.relatedMbl = adjustCharge.relatedMbl
        item.relationContainerNo = adjustCharge.relationContainerNo
        // 单价是否含税
        item.unitPriceIncludeTax = adjustCharge.unitPriceIncludeTax || false
      } else {
        this.charge.accountId = adjustCharge.accountId
        if (this.canChangeOverseaOfCharge) {
          this.charge.oversea = adjustCharge.oversea
        } else {
          const company = await Company.getCompanyById(Number(adjustCharge.accountId))
          if (company && Object.prototype.hasOwnProperty.call(company, 'cmpIdx')) {
            this.charge.oversea = company.overseaAgent
          }
        }
        this.charge.receivable = this.isAr
        this.charge.settlementAgentId = adjustCharge.settlementAgentId
        this.charge.chargeItemId = adjustCharge.chargeItemId
        this.charge.currency = adjustCharge.currency
        this.charge.measure = adjustCharge.measure
        this.charge.quantity = parseFloat(adjustCharge.quantity)
        this.charge.unitRate = parseFloat(adjustCharge.unitRate)
        this.charge.taxRate = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxRate))
        this.charge.amount = ChargeUtils.getRoundingValue(Number(adjustCharge.amount))
        this.charge.taxAmount = this.needInvoiceNo ? 0 : ChargeUtils.getRoundingValue(Number(adjustCharge.taxAmount))
        this.charge.excludingTaxAmount = this.needInvoiceNo ? item.amount : ChargeUtils.getRoundingValue(Number(adjustCharge.excludingTaxAmount))
        this.charge.verifiedAmount = 0
        if (this.needInvoiceNo) {
          this.charge.invoiceNo = adjustCharge.invoiceNo
        }
        this.charge.needInvoice = adjustCharge.needInvoice
        this.charge.controlled = adjustCharge.controlled
        const localCurrency = RateUtil.localCurrencyByOfficeId(adjustCharge.branchId)
        if (this.isAdjust) { this.charge.exchangeRate = isNaN(Number(adjustCharge.exchangeRate)) ? 0 : Number(adjustCharge.exchangeRate) } else { this.charge.exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.charge.currency, new Date(), adjustCharge.branchId) }
        this.charge.contactPerson = adjustCharge.contactPerson
        this.charge.remarks = adjustCharge.remarks
        this.charge.invoiceTitle = adjustCharge.invoiceTitle
        this.charge.relatedMbl = adjustCharge.relatedMbl
        this.charge.relationContainerNo = adjustCharge.relationContainerNo
        this.charge.unitPriceIncludeTax = adjustCharge.unitPriceIncludeTax || false
        if (this.salesDetail) {
          this.charge.ppcc = adjustCharge.ppcc
        }
      }
      if (this.applyChangeCharge) {
        const changeCharge = {}
        changeCharge.changeReason = this.changeReason
        changeCharge.branchId = this.$store.getters.currentOfficeId
        if (this.editMode === 'add') {
          changeCharge.actionType = 1
          changeCharge.chargeVO = item
        } else {
          changeCharge.actionType = 0
          changeCharge.chargeVO = this.charge
        }
        this.loading = getLoading()
        createChangeCharge(changeCharge).then(res => {
          if (res.data) {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.$emit('returnCall', res.data)
            this.close()
          }
        }).catch().finally(() => {
          this.loading.close()
        })
        return
      }
      // 费用调整保存
      const result = []
      if (this.editMode === 'add') {
        result.push(item)
      } else {
        result.push(this.charge)
      }
      this.loading = getLoading()
      await saveAdjustJob(result, { editMode: this.editMode, location: this.location }).then(res => {
        if (res.data) {
          this.$emit('returnCall', res.data)
          this.close()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    refreshSerialNumber(isAr, charges) {
      let number = 0
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    async onDateTypeChange(data) {
      this.dateType = data.value
      const exchangeDate = this.getExchangeDateByDateType(this.job, this.adjustCharge.auditDate)
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
      const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, exchangeDate, this.adjustCharge.branchId)
      this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '1' : exchangeRate.toString()
    },
    // 通过日期类型获取汇率对应日期
    getExchangeDateByDateType(job, adjustmentDate) {
      if (this.dateType === this.ADJUSTMENT_DATE.code) {
        return adjustmentDate
      } else if (this.dateType === this.BUSINESS_DATE.code) {
        return ['SE', 'AE', 'RE'].includes(job.lob) ? job.etd : job.eta
      } else {
        throw new Error('getExchangeDateByDateType: Not processed!')
      }
    },
    // 费用单位改变
    async onChangeCompany(result) {
      if (result) {
        const chargeItem = result
        this.adjustCharge.chargeItemId = Number(chargeItem.itemId)
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        this.adjustCharge.currency = StrUtils.isEmpty(chargeItem.defaultarcurrency) ? (StrUtils.isEmpty(this.adjustCharge.currency) ? localCurrency : this.adjustCharge.currency) : chargeItem.defaultarcurrency
        await this.textCurrencyChangeHandler(null)
        let accountId = 0
        if (this.isAr && chargeItem.defaultArCode) {
          if (chargeItem.defaultArCode === ChargeItemTarget.WTDW.code) {
            accountId = this.job.customerId
          } else if (chargeItem.defaultArCode === ChargeItemTarget.DCDW.code) {
            accountId = this.job.bookingAgent
          } else if (chargeItem.defaultArCode === ChargeItemTarget.MTGS.code) { // 码头公司
            if (this.job.lob === 'SE' || this.job.lob === 'SI') {
              accountId = this.job.terminalCompany
            }
          } else if (chargeItem.defaultArCode === ChargeItemTarget.CYR.code) {
            accountId = this.job.carrierId
          } else if (chargeItem.defaultArCode === ChargeItemTarget.HYDL.code) {
            accountId = this.job.destinationAgent
          } else if (chargeItem.defaultArCode === ChargeItemTarget.FYDL.code) {
            if (this.job.lob === 'RE' || this.job.lob === 'RI') {
              accountId = new RailwayExportJob(this.job).forwardingAgent
            }
          } else if (chargeItem.defaultArCode === ChargeItemTarget.FHR.code) {
            accountId = this.job.shipperId
          } else if (chargeItem.defaultArCode === ChargeItemTarget.SHR.code) {
            accountId = this.job.consigneeId
          } else if (chargeItem.defaultArCode === ChargeItemTarget.TZR.code) {
            accountId = this.job.notifyId
          }
        } else if (!this.isAr && chargeItem.defaultApCode) {
          if (chargeItem.defaultApCode === ChargeItemTarget.WTDW.code) {
            accountId = this.job.customerId
          } else if (chargeItem.defaultApCode === ChargeItemTarget.DCDW.code) {
            accountId = this.job.bookingAgent
          } else if (chargeItem.defaultArCode === ChargeItemTarget.MTGS.code) { // 码头公司
            if (this.job.lob === 'SE' || this.job.lob === 'SI') {
              accountId = this.job.terminalCompany
            }
          } else if (chargeItem.defaultApCode === ChargeItemTarget.CYR.code) {
            accountId = this.job.carrierId
          } else if (chargeItem.defaultApCode === ChargeItemTarget.HYDL.code) {
            accountId = this.job.destinationAgent
          } else if (chargeItem.defaultApCode === ChargeItemTarget.FYDL.code) {
            if (this.job.lob === 'RE' || this.job.lob === 'RI') {
              accountId = new RailwayExportJob(this.job).forwardingAgent
            }
          } else if (chargeItem.defaultApCode === ChargeItemTarget.FHR.code) {
            accountId = this.job.shipperId
          } else if (chargeItem.defaultApCode === ChargeItemTarget.SHR.code) {
            accountId = this.job.consigneeId
          } else if (chargeItem.defaultApCode === ChargeItemTarget.TZR.code) {
            accountId = this.job.notifyId
          }
        }
        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        this.adjustCharge.taxRate = chargeItem.taxRate || 0
        // CARGO-31003 在新增费用时，直接对特定的费用进行受控
        this.adjustCharge.controlled = chargeItem?.controlled
        this.adjustCharge.needInvoice = chargeItem?.needInvoice

        this.adjustCharge.accountId = accountId
        if (this.adjustCharge.accountId > 0) await ChargeUtils.updateDefaultInvoiceTitle([this.adjustCharge])
        this.loadContacts(accountId)
        await this.refreshQuantity()
        this.recalculateAmountByUnitPriceIncludeTax()
        const company = await Company.getCompanyById(accountId)
        if (company && Object.prototype.hasOwnProperty.call(company, 'cmpIdx')) {
          if (this.canChangeOverseaOfChargeValue < 2) {
            this.adjustCharge.oversea = (company.designationAgent || company.overseaAgent)
          }
        }
      }
    },
    // 修改费用项时，刷新数量
    async refreshQuantity() {
      const measure = this.adjustCharge.measure
      let quantity = this.adjustCharge.quantity
      if (measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'AE') {
          quantity = this.job.weightActual
        } else {
          quantity = this.job.weightActual / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
          const hbl2 = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else if (this.job.lob === 'AE') {
          quantity = this.job.weightActual / 1000
        } else {
          quantity = this.job.weightActual / 1000
          if (quantity < 1) quantity = 1
        }
      } else if (measure === 'WGTX') {
        if (this.job.lob === 'AE') {
          if (this.adjustCharge.receivable) {
            quantity = this.job.cWeight
          } else {
            const mawb = await this.job.getCargoDocByDocType(CargoDocConsts.MAWB)
            quantity = !mawb ? 0 : mawb.cWeight
          }
        } else {
          quantity = this.job.chargeWeight
        }
      } else if (measure === 'VOL') {
        quantity = this.job.cubageActual
      } else if (measure === 'MIN') {
        quantity = 1
      } else if (measure === 'NML') {
        quantity = 1
      } else {
        quantity = this.getEQQuantity(measure)
      }
      this.adjustCharge.measure = measure
      this.adjustCharge.quantity = Number(quantity.toFixed(3))
    },
    // 修改费用项时，获取数量
    getEQQuantity(type) {
      let n = 0
      if (this.job.seaEQ) {
        for (const eq of this.job.seaEQ) {
          if (type === 'C20') {
            if (eq.eqSize === '20') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40') {
            if (eq.eqSize === '40' && eq.eqType !== 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40H') {
            if (eq.eqSize === '40' && eq.eqType === 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C45') {
            if (eq.eqSize === '45') {
              n = n + eq.eqQuantity
            }
          }
        }
      }
      return n === 0 ? 1 : n
    },
    // 单位
    async combMeasureChangeHandler(result) {
      if (result) {
        this.adjustCharge.measure = result.code
      }
      await this.refreshQuantity()
      this.txtQuantityChangeHandler()
    },
    // 加载结算代理数据
    async loadSettlementAgents(accountId) {
      if (!accountId || accountId <= 0) {
        this.settlementAgentList = []
        this.adjustCharge.settlementAgentId = ''
        return
      }

      // 确保 settlementAgentList 始终是数组
      if (!this.settlementAgentList) {
        this.settlementAgentList = []
      }
      try {
        // 使用缓存数据初始化
        const cache = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', accountId)
        const cacheData = cache ? [cache] : []
        // 从API获取数据
        const res = await getSettlementAgentsByCmpIdx(accountId)
        const apiData = (res && Array.isArray(res.data)) ? res.data : []
        // 合并数据
        this.settlementAgentList = [...cacheData, ...apiData]
        // 如果当前选中的结算代理不在新的选项中，清空选择
        const currentAgentId = this.adjustCharge.settlementAgentId
        if (currentAgentId && !this.settlementAgentList.find(agent => agent.cmpIdx === currentAgentId)) {
          this.adjustCharge.settlementAgentId = ''
        }
      } catch (error) {
        this.settlementAgentList = []
      }
    },
    // 结算代理变更处理
    onSettlementAgentChange(item) {
      this.adjustCharge.settlementAgentId = item.value
    },
    // 修改结算对象时，调整税率
    async textAccountCode_changeHandler(result) {
      if (result) {
        const accountId = result.cmpIdx
        this.loadContacts(accountId) // 重新加载联系人
        this.adjustCharge.accountId = accountId
        // CARGO-21489，修改改单录入结算对象不会带出开票抬头
        if (this.adjustCharge.accountId > 0) await ChargeUtils.updateDefaultInvoiceTitle([this.adjustCharge])
        // 重新获取结算代理
        await this.loadSettlementAgents(accountId)
        this.adjustCharge.settlementAgentId = accountId
        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        ChargeUtils.changeChargeRateByAccountId(this.adjustCharge)
        this.recalculateAmountByUnitPriceIncludeTax()
        // 获取开票抬头列表并设置默认值
        await this.loadInvoiceTitle(accountId)
        if (this.canChangeOverseaOfChargeValue < 2) {
          this.adjustCharge.oversea = (result.designationAgent || result.overseaAgent)
        }
      }
    },
    // 数量
    txtQuantityChangeHandler() {
      const quantity = parseFloat(this.adjustCharge.quantity)
      if (!isNaN(quantity)) {
        this.adjustCharge.quantity = quantity
        if (this.adjustCharge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(this.adjustCharge, multiply(this.adjustCharge.unitRate, this.adjustCharge.quantity), this.adjustCharge.taxRate)
        } else {
          ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.quantity * this.adjustCharge.unitRate, this.adjustCharge.taxRate, true)
        }
      }
      this.adjustCharge.amount = this.adjustCharge.amount.toFixed(2)
    },
    // 单价
    txtUnitRateChangeHandler(result) {
      const unitRate = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 3))
      if (!isNaN(unitRate)) {
        this.adjustCharge.unitRate = unitRate
        if (this.adjustCharge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(this.adjustCharge, multiply(this.adjustCharge.unitRate, this.adjustCharge.quantity), this.adjustCharge.taxRate)
        } else {
          ChargeUtils.calculateTax(this.adjustCharge, multiply(this.adjustCharge.unitRate, this.adjustCharge.quantity), this.adjustCharge.taxRate)
        }
      }
      if (this.adjustCharge) {
        this.adjustCharge.amount = this.adjustCharge.amount.toFixed(3)
      }
    },
    // 修改含税价
    textAmountChangeHandler(result) {
      const amount = parseFloat(ChargeUtils.ToFixed(parseFloat(result), 2))
      if (!isNaN(amount)) {
        this.adjustCharge.amount = amount
        ChargeUtils.calculateTaxAmount(this.adjustCharge, amount, this.adjustCharge.taxRate)
      }
      if (this.adjustCharge) {
        this.adjustCharge.unitRate = this.adjustCharge.unitRate.toFixed(2)
      }
    },
    // 修改不含税金额
    excludingTaxAmountChangeHandler() {
      if (this.charge.advance) return
      if (!isNaN(this.adjustCharge.excludingTaxAmount)) {
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.excludingTaxAmount, this.adjustCharge.taxRate, true)
      }
    },
    unitPriceIncludeTaxChange(data) {
      this.adjustCharge.unitPriceIncludeTax = data.value
      ChargeColumnUtil.unitPriceIncludeTaxChange(this.adjustCharge)
    },
    recalculateAmountByUnitPriceIncludeTax() {
      if (this.adjustCharge.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(this.adjustCharge, multiply(this.adjustCharge.unitRate, this.adjustCharge.quantity), this.adjustCharge.taxRate)
      } else {
        ChargeUtils.calculateTax(this.adjustCharge, multiply(this.adjustCharge.unitRate, this.adjustCharge.quantity), this.adjustCharge.taxRate)
      }
    },
    // 税率
    txtRateChangeHandler() {
      if (this.charge.advance) return
      if (isNaN(this.adjustCharge.taxRate)) {
        this.adjustCharge.taxRate = 0.0
      }
      if (this.adjustCharge.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(this.adjustCharge, Number(this.adjustCharge.amount), this.adjustCharge.taxRate)
      } else {
        ChargeUtils.calculateTax(this.adjustCharge, this.adjustCharge.excludingTaxAmount, this.adjustCharge.taxRate, true)
      }
    },
    async textCurrencyChangeHandler(result) {
      if (this.isAdjust) {
        if (result) {
          this.adjustCharge.currency = result.code
        }
        this.selCurrency = this.adjustCharge.currency
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.adjustCharge.branchId)
        let exchangeRate
        if (this.salesDetail) {
          exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, this.adjustCharge.auditDate, this.adjustCharge.branchId)
        } else {
          const exchangeDate = this.getExchangeDateByDateType(this.job, this.adjustCharge.auditDate)
          exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.adjustCharge.currency, exchangeDate, this.adjustCharge.branchId)
        }
        this.adjustCharge.exchangeRate = isNaN(exchangeRate) ? '0' : exchangeRate.toString()
      }
    },
    // 加载结算对象所维护的联系人
    loadContacts(chargeAccountId) {
      getContacts({ cmpIdx: chargeAccountId }).then(res => {
        if (res.data) {
          this.contactArray = res.data
        }
      }).catch(error => {
        console.log('getContacts error', error)
      })
    },
    // 保存费用校验
    async validateCharge() {
      // Prevent from processing twice
      const job = new Job(this.job)
      if (job && job.charges && job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (!c.uuid) return false
        }
      }
      const adjustCharge = this.adjustCharge
      // if (!adjustCharge['auditDate']) {
      //   this.$message.warning(this.$t('Message.DateOfAdjustmentCannotBeNull'))
      //   return false
      // }
      if (isNaN(adjustCharge['accountId']) || Number(adjustCharge['accountId']) <= 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(adjustCharge['chargeItemId']) || Number(adjustCharge['chargeItemId']) <= 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(adjustCharge['quantity']) || Number(adjustCharge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(adjustCharge['exchangeRate']) || Number(adjustCharge['exchangeRate']) === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (adjustCharge['remarks'] && adjustCharge['remarks'].length > 256) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTheLengthCannotExceedP256'))
        return false
      }
      if (this.needInvoiceNo) {
        if (!adjustCharge['invoiceNo']) {
          this.$message.warning(this.$t('Message.InvoiceNoCannotBeNull'))
          return false
        }
        if (adjustCharge['invoiceNo'].length > 32) {
          this.$message.warning(this.$t('Message.InvoiceNoIsTooLong'))
          return false
        }
      }
      if (this.applyChangeCharge) {
        if (!this.changeReason) {
          this.$message.warning(this.$t('ChangeCharge.changeReasonCannotBeNull'))
          return false
        }
        if (this.changeReason.length > 100) {
          this.$message.warning(this.$t('ChangeCharge.changeReasonIsTooLong'))
          return false
        }
      }
      if (adjustCharge['chargeItemId']) {
        const message = ChargeUtils.checkChargeRateRange(adjustCharge)
        if (message) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
          return
        }
      }
      if (!await ChargeUtils.checkUnitRate([adjustCharge], this)) {
        return false
      }
      return true
    },
    // 费用项目过滤
    getChargeItemFilter() {
      let filter = {}
      if (this.applyChangeCharge || this.isAdjust) {
        switch (this.lob) {
          case 'SE':
            filter = { seaExport: true }
            break
          case 'SI':
            filter = { seaImport: true }
            break
          case 'AE':
            filter = { airExport: true }
            break
          case 'AI':
            filter = { airImport: true }
            break
          case 'RE':
          case 'RI':
            filter = { railwayExport: true }
            break
          default:
        }
      } else {
        filter = { advance: this.isAdvance }
      }
      if (this.isAr) {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      }
      if (this.isSpecialExpenseEntryFunction) {
        filter.specialExpenseMarker = false
      }
      return filter
    },
    // 关闭时清空值
    clearInput() {
      this.selCurrency = ''
      this.editMode = null
      this.isAdjust = false // 是否调整
      this.salesDetail = false // 是否销售
      this.isAdvance = false
      this.needMakeInvoice = true
      this.isAr = false
      this.job = null
      this.charge = null
      this.needInvoiceNo = false
      const adjustCharge = this.adjustCharge
      adjustCharge['accountId'] = ''
      adjustCharge['contactPerson'] = ''
      adjustCharge['currency'] = ''
      adjustCharge['quantity'] = 1.000
      adjustCharge['unitRate'] = 1.00
      adjustCharge['invoiceNo'] = ''
      adjustCharge['chargeItemId'] = ''
      adjustCharge['excludingTaxAmount'] = 0.00
      adjustCharge['amount'] = 0.00
      adjustCharge['taxRate'] = 0.00
      adjustCharge['taxAmount'] = 0.00
      adjustCharge['auditDate'] = new Date()
      adjustCharge['remarks'] = ''
      adjustCharge['relatedMbl'] = ''
      adjustCharge['relationContainerNo'] = ''
      this.adjustCharge = {}
      this.changeReason = ''
    },
    cancel() {
      this.$confirm(this.$t('Message.CancelMotify'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.close()
      }).catch(() => {
      })
    },
    close() {
      this.clearInput()
      this.innerVisible = false
    },
    async initCargoDocSet() {
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      const mblCargoDocSet = []
      const hblCargoDocSet = []
      const j = this.job
      for (const seDoc of this.job.cargoDoc || []) {
        if (j.lob === 'SE' || j.lob === 'SI') {
          if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
            if (!StrUtils.isEmpty(this.job.mbl)) {
              seDoc.chargeRelatedBLNo = this.job.mbl
              mblCargoDocSet.push(seDoc)
            }
          } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
            if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.mblNbr2
              mblCargoDocSet.push(seDoc)
            }
          } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
            if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.hblNbr2
              hblCargoDocSet.push(seDoc)
            }
          }
        }
      }
      const optionsMBLValue = {}
      const optionsHBLValue = {}
      if (mblCargoDocSet.length > 0) {
        optionsMBLValue.label = 'MBL No.'
        optionsMBLValue.options = mblCargoDocSet
        optionsMBLValue.filterable = true
      }
      if (hblCargoDocSet.length > 0) {
        optionsHBLValue.label = 'HBL No.'
        optionsHBLValue.options = hblCargoDocSet
        optionsHBLValue.filterable = true
      }
      this.blOption = [optionsMBLValue, optionsHBLValue]
      const containerNoSet = []
      if (this.job.containers) {
        for (const c of this.job.containers) {
          if (c.containerNo && containerNoSet.indexOf(c) === -1) {
            containerNoSet.push(c)
          }
        }
      }
      this.relatedContainerOption = containerNoSet
    },
    // 开票抬头变更处理函数
    textInvoiceTitleChangeHandle(result) {
      if (result) {
        this.adjustCharge.invoiceTitle = result.value || result.title
      }
    },
    async loadShowInvoiceTitle() {
      if (this.charge && this.charge.accountId) {
        const res = await queryTitleByCpmIdx(this.charge.accountId)
        let dbTitles = res.data
        if (!dbTitles) dbTitles = []
        if (dbTitles.length > 0) {
          this.invoiceTitleList = dbTitles
        }
        if (!this.adjustCharge.invoiceTitle) {
          if (dbTitles.length > 0) {
            // 优先选择默认开票抬头，如果没有默认的则选择第一个
            const defaultTitle = dbTitles.find(title => title.defaultTitle === true)
            const selectedTitle = defaultTitle || dbTitles[0]
            if (selectedTitle && selectedTitle.title) {
              this.adjustCharge.invoiceTitle = selectedTitle.title
            }
          } else {
            // 如果没有开票抬头数据，清空当前值
            this.adjustCharge.invoiceTitle = ''
            this.invoiceTitleList = []
          }
        }
      }
    },
    // 获取开票抬头列表
    async loadInvoiceTitle(accountId) {
      let dbTitles = []
      if (accountId) {
        const res = await queryTitleByCpmIdx(accountId)
        if (res.data && res.data.length > 0) {
          dbTitles = res.data
        }
      }
      if (dbTitles.length > 0) {
        this.invoiceTitleList = dbTitles
        // 优先选择默认开票抬头，如果没有默认的则选择第一个
        const defaultTitle = dbTitles.find(title => title.defaultTitle === true)
        const selectedTitle = defaultTitle || dbTitles[0]
        if (selectedTitle && selectedTitle.title) {
          this.adjustCharge.invoiceTitle = selectedTitle.title
        }
      } else {
        // 如果没有开票抬头数据，清空当前值
        this.adjustCharge.invoiceTitle = ''
        this.invoiceTitleList = []
      }
    }
  }
}
</script>
<style lang="scss">
  .change-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
    .input-center input {
      text-align: center;
    }
  }
</style>
